import { useEffect, useState } from "react";


const IMG_BASE = process.env.REACT_APP_IMAGE_URL ||process.env.REACT_APP_IMG_URL || "";
export const img = (p) => (!p ? "" : /^(https?:|data:|blob:)/.test(p) ? p : IMG_BASE + p);

export const initials = (name = "") =>
  name
    .replace(/^(optom\.|dr\.|mr\.|mrs\.|ms\.)\s*/i, "")
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0].toUpperCase())
    .join("");

export const clamp = (n, a = 0, b = 1) => Math.min(b, Math.max(a, n));


export const spotlight = (e) => {
  const r = e.currentTarget.getBoundingClientRect();
  e.currentTarget.style.setProperty("--mx", `${e.clientX - r.left}px`);
  e.currentTarget.style.setProperty("--my", `${e.clientY - r.top}px`);
};


export const stagger = { hide: {}, show: { transition: { staggerChildren: 0.09 } } };
export const rise = {
  hide: { opacity: 0, y: 44 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] } },
};
export const inView = { once: true, margin: "-80px" };

export const useMediaQuery = (query) => {
  const [matches, setMatches] = useState(
    () => typeof window !== "undefined" && !!window.matchMedia && window.matchMedia(query).matches
  );
  useEffect(() => {
    if (!window.matchMedia) return undefined;
    const mq = window.matchMedia(query);
    const on = () => setMatches(mq.matches);
    on();
    if (mq.addEventListener) mq.addEventListener("change", on);
    else mq.addListener(on);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener("change", on);
      else mq.removeListener(on);
    };
  }, [query]);
  return matches;
};